module.exports = __webpack_public_path__ + "static/woman-fridge-square.1b0242cb.jpg";